<template>
  <div id="scheduleDetail_startList">
    <NOT_DATA
      :className="'relativePtb30'"
      v-if="startListProp && !startListProp.isHasData"
    />
    <template v-else>
      <div class="shareMenuRow">
        <MultipleChoiceSharingMenuRow
          v-if="
            MultipleChoiceSharingMenuRow_list &&
            MultipleChoiceSharingMenuRow_list.length > 0
          "
          :list="MultipleChoiceSharingMenuRow_list"
          :baseOpt="MultipleChoiceSharingMenuRow_baseOpt"
          @clickMenuEvent="MultipleChoiceSharingMenuRow_clickMenuHandler"
          @clickPublicThemeEvent="
            MultipleChoiceSharingMenuRow_clickPublicThemeHandler
          "
        ></MultipleChoiceSharingMenuRow>
      </div>
      <EVENTCOP_MODE_3
        v-if="
          startListProp &&
          startListProp.eventCompMode === 'mode_3' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="startListProp.type"
        :competitorType="startListProp.competitorType"
      ></EVENTCOP_MODE_3>

      <EVENTCOP_MODE_4
        v-if="
          startListProp &&
          startListProp.eventCompMode === 'mode_4' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :axiosBaseUrl="axiosBaseUrl"
        :curTimeZoneItem="curTimeZoneItem"
      ></EVENTCOP_MODE_4>

      <EVENTCOP_MODE_10
        v-if="
          startListProp &&
          startListProp.eventCompMode === 'mode_10' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="startListProp.type"
        :competitorType="startListProp.competitorType"
      ></EVENTCOP_MODE_10>

      <EVENTCOP_MODE_11
        v-if="
          startListProp &&
          startListProp.eventCompMode === 'mode_11' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="startListProp.type"
        :madeType="'double'"
        :sportCompetitionType="sportCompetitionType"
      ></EVENTCOP_MODE_11>

      <EVENTCOP_MODE_13
        v-if="
          startListProp &&
          startListProp.eventCompMode === 'mode_13' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="startListProp.type"
        :competitorType="startListProp.competitorType"
      ></EVENTCOP_MODE_13>

      <EVENTCOP_MODE_14
        v-if="
          startListProp &&
          startListProp.eventCompMode === 'mode_14' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="startListProp.type"
        :competitorType="startListProp.competitorType"
      ></EVENTCOP_MODE_14>

      <EVENTCOP_MODE_15
        v-if="
          startListProp &&
          startListProp.eventCompMode === 'mode_15' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="startListProp.type"
        :competitorType="startListProp.competitorType"
      ></EVENTCOP_MODE_15>

      <EVENTCOP_MODE_18
        v-if="
          startListProp &&
          startListProp.eventCompMode === 'mode_18' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="startListProp.type"
        :competitorType="startListProp.competitorType"
      ></EVENTCOP_MODE_18>

      <EVENTCOP_MODE_20
        v-if="
          startListProp &&
          startListProp.eventCompMode === 'mode_20' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="startListProp.type"
        :competitorType="startListProp.competitorType"
      ></EVENTCOP_MODE_20>

      <EVENTCOP_MODE_24
        v-if="
          startListProp &&
          startListProp.eventCompMode === 'mode_24' &&
          eventCompModeDatas
        "
        :currThemeObj="currThemeObj"
        :currCid="currCid"
        :currSid="currSid"
        :sportsTypeArr="sportsTypeArr"
        :currSportsDetail="currSportsDetail"
        :datas="eventCompModeDatas"
        :tabType="startListProp.type"
        :competitorType="startListProp.competitorType"
        :isCombatFlag="startListProp.isCombatFlag"
      ></EVENTCOP_MODE_24>

      <!-- <div class="note_box">
          <span class="note_title" v-text="'注释'"></span>
          <span class="note_info">
            <span
              class="noteInfo_item"
              v-for="i in 12"
              :key="i"
              v-text="'M：脱靶'"
            ></span>
          </span>
        </div> -->
      <div
        class="note_box"
        v-show="
          eventCompModeDatas.annotation &&
          eventCompModeDatas.annotation.length > 0
        "
      >
        <span class="note_title" v-text="'注释'"></span>
        <span class="note_info">
          <span
            class="noteInfo_item"
            v-for="(item, index) in eventCompModeDatas.annotation"
            :key="index"
            v-text="`${item.name}：${item.explain}`"
          ></span>
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
import single_findAnalysisItem_data_mixin from '@mixins/single_findAnalysisItem_data'
import MultipleChoiceSharingMenuRow from '@components/base/theme/multipleChoiceSharingMenuRow.vue'
import NOT_DATA from '@components/base/NO_DATA.vue'
import EVENTCOP_MODE_3 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_3.vue'
import EVENTCOP_MODE_4 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_4.vue'
import EVENTCOP_MODE_10 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_10.vue'
import EVENTCOP_MODE_11 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_11.vue'
import EVENTCOP_MODE_13 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_13.vue'
import EVENTCOP_MODE_14 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_14.vue'
import EVENTCOP_MODE_15 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_15.vue'
import EVENTCOP_MODE_18 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_18.vue'
import EVENTCOP_MODE_20 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_20.vue'
// import EVENTCOP_MODE_23 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_23.vue'
import EVENTCOP_MODE_24 from '@components/platfromBase/compreSportsMeet/matchDetail_eventComp/eventComp_mode_24.vue'
export default {
  name: 'scheduleDetail_startList',
  mixins: [cup_base_data_mixin, single_findAnalysisItem_data_mixin],
  components: {
    MultipleChoiceSharingMenuRow,
    NOT_DATA,
    EVENTCOP_MODE_3,
    EVENTCOP_MODE_4,
    EVENTCOP_MODE_10,
    EVENTCOP_MODE_11,
    EVENTCOP_MODE_13,
    EVENTCOP_MODE_14,
    EVENTCOP_MODE_15,
    EVENTCOP_MODE_18,
    EVENTCOP_MODE_20,
    // EVENTCOP_MODE_23,
    EVENTCOP_MODE_24,
  },
  props: {
    currSportsDetail: {
      type: Object,
      default: () => ({}),
    },
    sportsTypeArr: {
      type: Array,
      default: () => {
        return []
      },
    },
    scheduleDetailDatas: {
      type: Object,
      default: () => ({}),
    },
    startListProp: {
      type: Object,
      default: () => ({
        datas: null, //初始化时为null, 一旦赋值过只能为正常数据||{}
        isHasData: true,
        eventCompMode: '', //mode_1
        type: '',
        competitorType: '',
      }),
    },
    multipleChoiceSharingMenuRow_themeList: {
      type: [Array, null],
      default: () => {
        return []
      },
    },
    sportCompetitionType: {
      type: String, //赛事类型
      default: '',
    },
  },
  watch: {
    startListProp: {
      handler(newVal, oldVal) {
        console.debug('startList 刷新数据:', newVal, oldVal)
        if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
          this.eventCompModeDatas = JSON.parse(
            JSON.stringify(newVal.datas ? newVal.datas : {})
          )
          console.debug('eventCompModeDatas:', this.eventCompModeDatas)
        }
      },
      immediate: true,
      deep: true,
    },
    multipleChoiceSharingMenuRow_themeList: {
      handler(newVal, oldVal) {
        console.debug('themeList 刷新数据:', newVal, oldVal)
        if (newVal && newVal !== oldVal) {
          this.themeList = newVal
          this.themeListCallback()
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      // eventCompMode: 'mode_2',
      eventCompModeDatas: null,
      MultipleChoiceSharingMenuRow_baseOpt: {
        openMenuWidthVw: '20vw', // 打开的总宽度
        closeMenuWidthVw: '6.4vw', // 收起来的总宽度
      },
      MultipleChoiceSharingMenuRow_originBaseOpt: [
        {
          openMenuWidthVw: '13.8vw', // 打开的总宽度
          closeMenuWidthVw: '6.4vw', // 收起来的总宽度
        },
        {
          openMenuWidthVw: '20vw', // 打开的总宽度
          closeMenuWidthVw: '6.4vw', // 收起来的总宽度
        },
        {
          openMenuWidthVw: '30vw', // 打开的总宽度
          closeMenuWidthVw: '6.4vw', // 收起来的总宽度
        },
      ],
      MultipleChoiceSharingMenuRow_list: null,
    }
  },
  mounted() {
    // this.$nextTick(() => {
    //   window.scrollTo(0, Math.floor((12.36+0.694) * this.vw2px))
    // })
  },
  methods: {
    MultipleChoiceSharingMenuRow_clickMenuHandler(item) {
      this.MultipleChoiceSharingMenuRow_list.forEach((menuItem, meunIndex) => {
        if (item.id === menuItem.id) {
          menuItem.isAct = true
          this.themeItem = this.themeList[meunIndex]
        } else {
          menuItem.isAct = false
        }
      })
    },
    MultipleChoiceSharingMenuRow_clickPublicThemeHandler(item) {
      let themeItem = this.themeItem
      if (themeItem) {
        this.clickPublicTheme(themeItem)
      } else {
        console.error('没有找到对应分享的主题数据：themeItem')
      }
    },
    themeListCallback() {
      if (this.themeList && this.themeList.length > 0) {
        let MultipleChoiceSharingMenuRow_list = []
        // 重置分享按钮的名字
        this.themeList.forEach((shareItem, shareIndex) => {
          MultipleChoiceSharingMenuRow_list.push({
            id: `${shareItem.analysisItemId}_${shareIndex}`,
            name: shareItem.twoTitle,
            isAct: false,
          })
        })
        let themeList_length = this.themeList.length
        this.MultipleChoiceSharingMenuRow_list =
          MultipleChoiceSharingMenuRow_list
        // 不同的主题个数，分享按钮的长度不一样
        this.MultipleChoiceSharingMenuRow_baseOpt =
          this.MultipleChoiceSharingMenuRow_originBaseOpt[themeList_length - 1]
        // 选中最后一个分享按钮【高亮】
        this.MultipleChoiceSharingMenuRow_clickMenuHandler(
          this.MultipleChoiceSharingMenuRow_list[themeList_length - 1]
        )
      } else {
        this.themeList = []
        this.MultipleChoiceSharingMenuRow_list = null
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#scheduleDetail_startList {
  padding-bottom: 2.083vw;
  .shareMenuRow {
    padding-top: 1.38vw;
  }
  .note_box {
    width: 100%;
    padding: 0.694vw 1.338vw 4.16vw;
    /* border-top: 1px solid var(--mixtmt_greyColor8); */
    .note_title {
      display: block;
      font-size: 1.11vw;
      color: var(--mixtmt_mainColor);
      line-height: 2.083vw;
      font-weight: bold;
    }
    .note_info {
      width: 100%;
      padding: 0 0.694vw 0 0;
      height: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .noteInfo_item {
        width: auto;
        min-width: 12.5%;
        text-align: left;
        font-size: 1.11vw;
        line-height: 2.5vw;
        color: var(--mixtmt_greyColor2);
        padding-left: 1.388vw;
        &:first-child {
          padding-left: 0.694vw;
        }
      }
    }
  }
}
</style>
